var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advertisement"},[_c('h3',{staticClass:"advertisement_title"},[_vm._v("广告")]),_c('div',[_c('DeliverySettings',{attrs:{"delivery_settings":_vm.advertisement.deliverySettings}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }